import React from 'react';
import classNames from 'classnames';
import styles from './NoResultsFound.module.scss';

export interface NoResultsFoundProps {
  title: string;
  smallTitle?: boolean;
  className?: string;
}

const NoResultsFound: React.FC<NoResultsFoundProps> = ({ title, smallTitle, className }) => {
  return (
    <div className={classNames(styles.root, className, { [styles.reduced]: smallTitle })}>
      <div
        className={classNames('text-faded', {
          'typo-title-24': !smallTitle,
          'typo-text-14': smallTitle,
        })}>
        {title}
      </div>
    </div>
  );
};

export default NoResultsFound;
